module.exports = __webpack_public_path__ + "img/char.242ece0c.png";